import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFirebaseContext, useActiveListContext } from '../../../context';
import * as ROUTES from '../../../constants';
import { googleAuthProvider, emailAuthProvider } from '../../../lib';
import { Core } from '../..';
import { FaEnvelope } from 'react-icons/fa';

export default function UpgradeAccount({
  showUpgradeAccBox,
  setShowUpgradeAccBox,
}) {
  const history = useHistory();
  const { firebase } = useFirebaseContext();
  const [firstName, setFirstName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { themeColor, themeColor_L2 } = useActiveListContext();
  const [progress, setProgress] = useState(0);

  const nameIncluded = firstName === '';
  const isInvalid = firstName === '' || password === '' || emailAddress === '';

  useEffect(() => {
    if (!showUpgradeAccBox) {
      setError('');
    }
  }, [showUpgradeAccBox]);

  return (
    <>
      <Core.Loading
        color={themeColor}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Core.CardContainer
        width='25vw'
        minWidth='392px'
        showBox={showUpgradeAccBox}
        setShowBox={setShowUpgradeAccBox}
      >
        <Core.Title>Link Account.</Core.Title>

        <Core.ListLayout>
          {showUpgradeAccBox && error != '' && <Core.Error>{error}</Core.Error>}
          <Core.Input
            autoFocus
            placeholder='Username'
            value={firstName}
            style={{ marginBottom: '10px' }}
            onChange={({ target }) => setFirstName(target.value)}
          />

          <Core.Input
            placeholder='Email address'
            value={emailAddress}
            style={{ marginBottom: '10px' }}
            onChange={({ target }) => setEmailAddress(target.value)}
          />

          <Core.Input
            type='password'
            placeholder='Password'
            autoComplete='off'
            value={password}
            style={{ marginBottom: '10px' }}
            onChange={({ target }) => setPassword(target.value)}
          />

          <Core.Button
            color={'white'}
            bg={themeColor}
            style={{ marginBottom: '25px' }}
            shadowBorder={false}
            disabled={isInvalid}
            type='button'
            onClick={() => {
              setError('');
              setProgress(95);
              firebase
                .auth()
                .currentUser.linkWithCredential(
                  emailAuthProvider.credential(emailAddress, password)
                )
                .then((result) => {
                  result.user
                    .updateProfile({
                      displayName: firstName,
                    })
                    .then(() => {
                      history.push('/');
                      history.push(ROUTES.DASHBOARD);
                    });
                })

                .catch((error) => {
                  setProgress(100);
                  setFirstName('');
                  setEmailAddress('');
                  setPassword('');
                  setError(error.message);
                });
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <FaEnvelope
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              <span>Link with Mail</span>
            </div>
          </Core.Button>

          <Core.Button
            color={themeColor}
            bg={themeColor_L2}
            disabled={nameIncluded}
            shadowBorder={true}
            type='button'
            onClick={() => {
              setError('');

              firebase
                .auth()
                .currentUser.linkWithPopup(googleAuthProvider)
                .then((result) => {
                  result.user
                    .updateProfile({
                      displayName: firstName,
                    })
                    .then(() => {
                      history.push('/');
                      history.push(ROUTES.DASHBOARD);
                    });
                })

                .catch((error) => {
                  setError(error.message);
                });
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <img
                src='https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg'
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              <span>Link with Google</span>
            </div>
          </Core.Button>
        </Core.ListLayout>
      </Core.CardContainer>
    </>
  );
}
